import { useEffect } from "react";

import { FancySpinner } from "../../common/fancy-spinner.js";

interface FullScreenLoaderProps {
  message: string;
  redirectUrl?: string;
}

export const FullScreenLoader = ({
  message,
  redirectUrl,
}: FullScreenLoaderProps) => {
  useEffect(() => {
    if (redirectUrl) {
      window.location.replace(redirectUrl);
    }
  }, [redirectUrl]);

  return (
    <div className="flex h-screen w-screen items-center justify-center bg-white">
      <div className="flex flex-col items-center space-y-4">
        <FancySpinner />
        <p className="text-lg text-gray-600">{message}</p>
      </div>
    </div>
  );
};
